<template>
  <div class="select">
    <div class="select__btns">
      <button
        v-for="(btn, index) in btns"
        :key="index"
        type="button"
        :disabled="disabled"
        class="select__btn"
        :class="{ 'is-active': btn[props.mapKey] === value }"
        @click.prevent.stop="btnClick(btn)"
      >
        {{ btn[props.name] }}
      </button>
    </div>
  </div>
</template>

<script>
import emitter from 'element-ui/src/mixins/emitter'
const props = {
  mapKey: 'classifyNo',
  name: 'classifyName'
}
export default {
  mixins: [emitter],
  props: {
    btns: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    props: {
      type: Object,
      default: () => (props)
    }
  },
  methods: {
    btnClick(btn) {
      this.$emit('input', btn[this.props.mapKey])
      this.dispatch('ElFormItem', 'el.form.change')
    }
  }
}
</script>

<style lang="scss" scoped>
.select {
  display: flex;
  align-items: center;
  &__name {
      font-size: 12px;
      color: #666666;
      width: 50px;
  }
  &__btns {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
  }
  &__btn {
      border: none;
      outline: none;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      padding: 0 20px;
      height: 30px;
      border-radius: 15px;
      background: #F4F4F4;
      margin: 5px 15px;
      cursor: pointer;
      &.is-active {
      background: #E7F6FF;
      color: #008EE3;
      }
  }
}
</style>
